import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setSchedulerModeView } from '../../../actions/areas/dailyPlanning';
import useTimeline from '../timeline/useTimeline';

export function DayNightSwitch() {
  const { resetContext } = useTimeline();
  const isNightMode = useSelector(state => state.areas.dailyPlanning.scheduler.isNightMode);

  const dispatch = useDispatch();
  const setScheduleMode = isNight => dispatch(setSchedulerModeView(isNight));

  const toggleDayNightMode = () => {
    if (resetContext && typeof resetContext === 'function') resetContext();
    setScheduleMode(!isNightMode);
  };

  return (
    <div
      id="dayNightToggle"
      className="switch-container"
      role="switch"
      tabIndex="-1"
      aria-checked="true"
      onClick={toggleDayNightMode}
    >
      <div className={isNightMode ? 'toggle-btn night-mode' : 'toggle-btn day-mode'}>
        <div className="inner" />
      </div>
    </div>
  );
}
